import 'dayjs/locale/ja'

import App from 'App'
import { APIKeyContext, initialAPIKeyContext } from 'contexts/APIKeyContext'
import {
  EditingItemContext,
  initialEditingItemContext
} from 'contexts/EditingItemContext'
import {
  HistoryStackContext,
  initialHistoryStackContext
} from 'contexts/HistoryStackContext'
import { initialJwtContext, JwtContext } from 'contexts/JwtContext'
import {
  initialScrollLockContext,
  ScrollLockContext
} from 'contexts/ScrollLockContext'
import {
  initialWebSocketUtilsContext,
  WebSocketUtilsContext
} from 'contexts/WebSocketUtilsContext'
import dayjs from 'dayjs'
import ErrorBoundary from 'ErrorBoundary'
import GATag from 'GATag'
import GlobalStyle from 'GlobalStyle'
import React, { ReactNode, useState } from 'react'
import ScrollToTop from 'ScrollToTop'
import { useEditingItemState, useJwtState } from 'utils/commonHooks'
import { useListenBrowserAction } from 'utils/log'
import WebSocketDisconnectModal from 'WebSocketDisconnectModal'

dayjs.locale('ja')

/**
 * AppWrapperコンポーネント
 * グローバルなCSS適用
 * 操作履歴スタックの登録
 * スクロールロック
 * フロントエラーのキャッチ
 * アプリケーションのレンダリング を行う
 */
const AppWrapper: React.FC = () => {
  const historyContexts = useState(initialHistoryStackContext)
  const lockContexts = useState(initialScrollLockContext)
  const webSocketUtilsContext = useState(initialWebSocketUtilsContext)
  const editingItemContexts = useEditingItemState(initialEditingItemContext)
  const jwtContexts = useJwtState(initialJwtContext)
  const apiKeyContexts = useState(initialAPIKeyContext)
  useListenBrowserAction()

  return (
    <ScrollLockContext.Provider value={lockContexts}>
      <GlobalStyle />
      <HistoryStackContext.Provider value={historyContexts}>
        <WebSocketUtilsContext.Provider value={webSocketUtilsContext}>
          <EditingItemContext.Provider value={editingItemContexts}>
            <JwtContext.Provider value={jwtContexts}>
              <APIKeyContext.Provider value={apiKeyContexts}>
                <HistoryStackContext.Consumer>
                  {(historyStack): ReactNode => (
                    <JwtContext.Consumer>
                      {(jwt): ReactNode => (
                        <ErrorBoundary jwt={jwt} historyStack={historyStack}>
                          <ScrollToTop />
                          <GATag />
                          <App />
                          <WebSocketDisconnectModal />
                        </ErrorBoundary>
                      )}
                    </JwtContext.Consumer>
                  )}
                </HistoryStackContext.Consumer>
              </APIKeyContext.Provider>
            </JwtContext.Provider>
          </EditingItemContext.Provider>
        </WebSocketUtilsContext.Provider>
      </HistoryStackContext.Provider>
    </ScrollLockContext.Provider>
  )
}

export default AppWrapper
